<template>
  <div class="alipay-demo">
    <div class="container">
      <h1>支付宝个人支付接口 Demo</h1>
      
      <!-- 支付表单 -->
      <div class="payment-form">
        <h2>创建支付订单</h2>
        <div class="form-item">
          <label>订单金额（元）</label>
          <input type="number" v-model="orderAmount" placeholder="请输入金额" step="0.01" min="0.01">
        </div>
        <div class="form-item">
          <label>商品名称</label>
          <input type="text" v-model="orderSubject" placeholder="请输入商品名称">
        </div>
        <div class="form-item">
          <label>商品描述</label>
          <textarea v-model="orderBody" placeholder="请输入商品描述"></textarea>
        </div>
        <button class="create-btn" @click="createPaymentOrder" :disabled="isCreating">
          {{ isCreating ? '创建中...' : '创建支付订单' }}
        </button>
      </div>
      
      <!-- 支付二维码 -->
      <div class="payment-qr" v-if="showQrCode">
        <h2>支付宝扫码支付</h2>
        <div class="qr-container">
          <div class="qr-image">
            <img :src="qrCodeUrl" alt="支付宝支付二维码" />
          </div>
          <div class="qr-info">
            <p>订单号：{{ currentOrderNo }}</p>
            <p>金额：{{ orderAmount }} 元</p>
            <p>商品：{{ orderSubject }}</p>
            <button class="check-btn" @click="checkPaymentStatus">
              检查支付状态
            </button>
          </div>
        </div>
      </div>
      
      <!-- 支付结果 -->
      <div class="payment-result" v-if="showResult">
        <h2>支付结果</h2>
        <div class="result-card" :class="paymentSuccess ? 'success' : 'failed'">
          <div class="result-icon">{{ paymentSuccess ? '✓' : '✗' }}</div>
          <h3>{{ paymentSuccess ? '支付成功' : '支付失败' }}</h3>
          <p v-if="paymentSuccess">订单已支付成功，感谢您的购买！</p>
          <p v-else>支付失败，请重新尝试。</p>
          <div class="result-info" v-if="paymentSuccess">
            <p>订单号：{{ currentOrderNo }}</p>
            <p>支付时间：{{ payTime }}</p>
          </div>
          <button class="reset-btn" @click="resetForm">
            重新支付
          </button>
        </div>
      </div>
      
      <!-- 订单状态查询 -->
      <div class="order-query">
        <h2>订单状态查询</h2>
        <div class="query-form">
          <input type="text" v-model="queryOrderNo" placeholder="请输入订单号">
          <button class="query-btn" @click="queryOrderStatus">
            查询状态
          </button>
        </div>
        <div class="query-result" v-if="orderStatus">
          <h3>订单状态</h3>
          <div class="status-info">
            <p><strong>订单号：</strong>{{ orderStatus.orderNo }}</p>
            <p><strong>状态：</strong>{{ getStatusText(orderStatus.status) }}</p>
            <p><strong>金额：</strong>{{ orderStatus.amount }} 元</p>
            <p><strong>商品：</strong>{{ orderStatus.subject }}</p>
            <p><strong>创建时间：</strong>{{ formatDate(orderStatus.createTime) }}</p>
            <p v-if="orderStatus.payTime"><strong>支付时间：</strong>{{ formatDate(orderStatus.payTime) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import apiConfig from '@/config/api.js'

export default {
  name: 'AlipayDemoView',
  data() {
    return {
      orderAmount: '1.00',
      orderSubject: '测试商品',
      orderBody: '这是一个测试商品',
      isCreating: false,
      showQrCode: false,
      showResult: false,
      qrCodeUrl: '',
      currentOrderNo: '',
      paymentSuccess: false,
      payTime: '',
      queryOrderNo: '',
      orderStatus: null
    }
  },
  methods: {
    async createPaymentOrder() {
      if (!this.orderAmount || !this.orderSubject) {
        alert('请填写金额和商品名称');
        return;
      }
      
      this.isCreating = true;
      try {
        const response = await axios.post(apiConfig.payment.alipayDemoCreate, {
          amount: this.orderAmount,
          subject: this.orderSubject,
          body: this.orderBody
        });
        
        if (response.data.code === 200) {
          this.qrCodeUrl = response.data.data.qrCode;
          this.currentOrderNo = response.data.data.orderNo;
          this.showQrCode = true;
          this.showResult = false;
        } else {
          alert('创建支付订单失败：' + response.data.message);
        }
      } catch (error) {
        console.error('创建支付订单失败:', error);
        alert('创建支付订单失败，请稍后重试');
      } finally {
        this.isCreating = false;
      }
    },
    
    async checkPaymentStatus() {
      try {
        const response = await axios.get(apiConfig.payment.alipayDemoStatus(this.currentOrderNo));
        
        if (response.data.code === 200) {
          const status = response.data.data;
          if (status.status === 'PAID') {
            this.paymentSuccess = true;
            this.payTime = this.formatDate(status.payTime);
            this.showResult = true;
            this.showQrCode = false;
          } else {
            alert('支付尚未完成，请继续扫码支付');
          }
        } else {
          alert('查询支付状态失败：' + response.data.message);
        }
      } catch (error) {
        console.error('查询支付状态失败:', error);
        alert('查询支付状态失败，请稍后重试');
      }
    },
    
    async queryOrderStatus() {
      if (!this.queryOrderNo) {
        alert('请输入订单号');
        return;
      }
      
      try {
        const response = await axios.get(apiConfig.payment.alipayDemoStatus(this.queryOrderNo));
        
        if (response.data.code === 200) {
          this.orderStatus = response.data.data;
        } else {
          alert('查询订单状态失败：' + response.data.message);
          this.orderStatus = null;
        }
      } catch (error) {
        console.error('查询订单状态失败:', error);
        alert('查询订单状态失败，请稍后重试');
        this.orderStatus = null;
      }
    },
    
    getStatusText(status) {
      const statusMap = {
        'PENDING': '待支付',
        'PAID': '已支付',
        'REFUNDED': '已退款',
        'FAILED': '支付失败'
      };
      return statusMap[status] || status;
    },
    
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleString();
    },
    
    resetForm() {
      this.showResult = false;
      this.showQrCode = false;
      this.paymentSuccess = false;
      this.qrCodeUrl = '';
      this.currentOrderNo = '';
      this.payTime = '';
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-demo {
  padding: 40px 0;
  min-height: 80vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 40px;
  font-size: 32px;
}

h2 {
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
  border-bottom: 2px solid #1890ff;
  padding-bottom: 10px;
}

.payment-form {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 12px;
  margin-bottom: 40px;
}

.form-item {
  margin-bottom: 20px;
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
  }
  input,
  textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    font-size: 16px;
    transition: all 0.3s ease;
    &:focus {
      outline: none;
      border-color: #1890ff;
    }
  }
  textarea {
    resize: vertical;
    min-height: 100px;
  }
}

.create-btn,
.check-btn,
.query-btn,
.reset-btn {
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    opacity: 0.9;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
}

.create-btn,
.check-btn {
  background-color: #1890ff;
  color: #fff;
  &:hover {
    background-color: #40a9ff;
  }
}

.payment-qr {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 12px;
  margin-bottom: 40px;
}

.qr-container {
  display: flex;
  align-items: center;
  gap: 40px;
  flex-wrap: wrap;
  .qr-image {
    flex-shrink: 0;
    img {
      width: 250px;
      height: 250px;
      border: 2px solid #e8e8e8;
      border-radius: 8px;
      background-color: #fff;
      display: block;
    }
  }
  .qr-info {
    flex: 1;
    min-width: 300px;
    p {
      margin-bottom: 10px;
      font-size: 16px;
      color: #333;
    }
  }
}

.payment-result {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 12px;
  margin-bottom: 40px;
}

.result-card {
  text-align: center;
  padding: 40px;
  border-radius: 12px;
  background-color: #fff;
  &.success {
    border: 2px solid #52c41a;
    .result-icon {
      color: #52c41a;
    }
    h3 {
      color: #52c41a;
    }
  }
  &.failed {
    border: 2px solid #ff4d4f;
    .result-icon {
      color: #ff4d4f;
    }
    h3 {
      color: #ff4d4f;
    }
  }
  .result-icon {
    font-size: 48px;
    margin-bottom: 20px;
  }
  h3 {
    font-size: 24px;
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 20px;
    color: #666;
  }
  .result-info {
    margin: 20px 0;
    p {
      text-align: left;
      margin-bottom: 5px;
    }
  }
}

.reset-btn {
  background-color: #1890ff;
  color: #fff;
  &:hover {
    background-color: #40a9ff;
  }
}

.order-query {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 12px;
}

.query-form {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  input {
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    font-size: 16px;
    &:focus {
      outline: none;
      border-color: #1890ff;
    }
  }
}

.query-btn {
  background-color: #1890ff;
  color: #fff;
  &:hover {
    background-color: #40a9ff;
  }
}

.query-result {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  .status-info {
    p {
      margin-bottom: 10px;
      color: #333;
    }
  }
}

@media (max-width: 768px) {
  .qr-container {
    flex-direction: column;
    text-align: center;
  }
  .query-form {
    flex-direction: column;
  }
}
</style>
